import { Suspense, type ReactNode } from "react";

/**
 * Envolve uma seção abaixo da dobra.
 *
 * - `content-visibility: auto` faz o navegador pular layout/paint do que está
 *   fora da viewport (o HTML continua vindo do SSR, então SEO e Ctrl+F seguem
 *   funcionando) e `contain-intrinsic-size` evita saltos na barra de rolagem.
 * - Cada bloco tem seu próprio `Suspense`, então um chunk lento não segura o
 *   streaming/hidratação das demais seções.
 */
export function DeferBlock({
  children,
  estimate = 600,
}: {
  children: ReactNode;
  /** Altura estimada em px, usada apenas como reserva de espaço. */
  estimate?: number;
}) {
  return (
    <div
      style={{ contentVisibility: "auto", containIntrinsicSize: `auto ${estimate}px` }}
    >
      <Suspense fallback={<div aria-hidden="true" className="min-h-[160px]" />}>
        {children}
      </Suspense>
    </div>
  );
}
